import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/404",
      name: "404",
      component: () => import('./views/error-page/404.vue')
    },
    {
      path: "/help",
      name: "help",
      component: () => import('./views/help/Help.vue')
    },
    {
      path: "/how",
      name: "how",
      component: () => import('./views/how/how.vue'),
      children: [
        {
          path: "active",
          name: "active",
          component: () => import('./views/how/active.vue'),
        },
        {
          path: "class",
          name: "class",
          component: () => import('./views/how/class.vue'),
        },
        {
          path: "assignment",
          name: "assignment",
          component: () => import('./views/how/assignment.vue'),
        },
        {
          path: "study",
          name: "study",
          component: () => import('./views/how/study.vue'),
        },
        {
          path: "buy",
          name: "buy",
          component: () => import('./views/how/buy.vue'),
        },
        {
          path: 'evaluate',
          name: 'evaluate',
          component: () => import('./views/how/evaluate.vue')
        },
        {
          path: 'medal',
          name: 'medal',
          component: () => import('./views/how/medal.vue')
        }
      ]
    },
    {
      path: "/more",
      name: "more",
      component: () => import('./views/more/more.vue'),
      children: [
        {
          path: "list",
          name: "list",
          component: () => import('./views/more/list.vue'),
        },
        {
          path: "c1",
          name: "c1",
          component: () => import('./views/more/away.vue'),
        },
        {
          path: "c2",
          name: "c2",
          component: () => import('./views/more/exit.vue'),
        },
        {
          path: "c3",
          name: "c3",
          component: () => import('./views/more/color.vue'),
        },
        {
          path: "c4", //登录激活等相关问题
          name: "c4",
          component: () => import('./views/more/login.vue'),
        },
        {
          path: "c5",
          name: "c5",
          component: () => import('./views/more/unbuy.vue'), //课程未购买
        },
        {
          path: "c6",
          name: "c6",
          component: () => import('./views/more/twochild.vue'), //两个孩子的问题
        },
        {
          path: "c7",
          name: "c7",
          component: () => import('./views/more/problem.vue') //使用中的相关问题
        },
        {
          path: "c8",
          name: "c8",
          component: () => import('./views/more/unget-task.vue') //未收到问题
        },
        {
          path: "c9",
          name: "c9",
          component: () => import('./views/more/logout.vue') //如何注销
        },
        {
          path: "c10",
          name: "c10",
          component: () => import('./views/more/change-info.vue') //如何修改个人信息
        },
        {
          path: 'c11',
          name: 'c11',
          component: () => import('./views/more/multiple-account.vue') //如何多账号管理
        },
        {
          path: 'c12',
          name: 'c12',
          component: () => import('./views/more/family-account.vue') //如何管理家庭账号组
        },
        {
          path: 'c13',
          name: 'c13',
          component: () => import('./views/more/clear-cache.vue') //如何清除缓存
        }
      ]
    },
    {
      path: "/option",
      name: "option",
      component: () => import('./views/option/option.vue')
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import('./views/privacy/privacy.vue')  //隐私政策
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import('./views/privacy/agreement.vue') //用户协议
    },
    {
        path: '/upload',
        name: 'upload',
        component: () => import('./views/privacy/upload.vue') //用户协议
    }
  ]
});
